import styled from "@emotion/styled";

export default styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 40px;
`;
